import { DEEPLINKS } from "../../adapters/constants";
import FullPageError from "../../components/FullPageError/FullPageError";

export function OutageWindow() {

    const { PPA_OUTAGE_NOTIFICATION_MESSAGE, PPA_ENV_MODE } = window.appConfig || {};
    const qs = sessionStorage.getItem('qs');
    const qp = new URLSearchParams(qs || '');
    const source = qp.get('source');
    const isEsimFlow = Boolean(qp.get('param') || source);
    let redirectionUrl;

    if (isEsimFlow) {
        const iosUrl = ['prod', 'staging'].includes(PPA_ENV_MODE)
            ? DEEPLINKS.IPHONE_PROD_ERROR
            : DEEPLINKS.IPHONE_DEV_ERROR;

        if (source) {
            if (source.toLowerCase()?.includes('android')) {
                redirectionUrl = DEEPLINKS.ANDROID_ERROR;
            } else {
                redirectionUrl = iosUrl;
            }
        } else {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/iPad|iPhone|iPod/.test(userAgent)) {
                redirectionUrl = iosUrl;
            } else {
                redirectionUrl = DEEPLINKS.ANDROID_ERROR;
            }
        }
    }
    if (isEsimFlow) {
        window.location.href = redirectionUrl;
    }
    return (
        <div className="container ppa-block outage-window mt-auto">
            <FullPageError
                errorText="Pre-Paid Activation Unavailable"
                errorMessage={PPA_OUTAGE_NOTIFICATION_MESSAGE}>
            </FullPageError>
        </div>
    );
}